// extracted by mini-css-extract-plugin
export default {"innerWrapper":"eC-z","tooltipWrapper":"fC-z","icon":"gC-z","tooltip":"hC-z","content":"iC-z"};